export type AnnotationType = "CREATION" | "INFO" | "DELETION" | "MODIFICATION";
export type AnnotationStatus = "TODO" | "DONE" | "IN_PROGRESS" | "NEW" | "ARCHIVED" | "PENDING";
export type AnnotationAuthor = [];

const doneOpacity = 0.42;
const todoOpacity = 1;


export class AnnotationPosition {
  constructor(public roomId: string, public x: number, public y: number) {}
}

export class AnnotationModel {
  constructor(
    public id: string,
    public roomId: string,
    public type: AnnotationType,
    public title: string,
    public content: string,
    public x: number,
    public y: number,
    public pictureBinary: string | null,
    public status: AnnotationStatus | null,
    public fileName: string | null,
    public location: string | null,
    public date: string | null,
    public siteId: string | null,
    public siteCode: string | null,
    public addedBy: string | null,
    public equipmentCode: string | null,
    public portfolio: string | null
  ) {}

  getColor() {
    // https://www.figma.com/file/gTGC7HmOhjmrqPor0BgYX1/One_system
    switch (this.type) {
      case "CREATION":
        return "#37981F"; // Status - Success
      case "INFO":
        return "#6448DE"; // Status - Error
      case "DELETION":
        return "#C6441B"; // Primary Stonal
      case "MODIFICATION":
        return "#E150FB";
    }
  }

  getOpacity() {
    return this.status === "DONE" ? doneOpacity : todoOpacity;
  }
}
